// destek.mbbe.dev (veya VITE_APP_TARGET=destek) ise müşteri destek portalı mount edilir.
const DESTEK_HOSTS = new Set(['destek.mbbe.dev', 'destek-staging.mbbe.dev', 'destek-passive.mbbe.dev', 'destek-staging-passive.mbbe.dev', 'destek.localhost']);

export function isDestekHost(): boolean {
  if (import.meta.env.VITE_APP_TARGET === 'destek') return true;
  if (typeof window === 'undefined') return false;
  return DESTEK_HOSTS.has(window.location.hostname.toLowerCase());
}
